
export const formatCurrency = (price, locale = 'en-US', currency = 'USD') => {
    const FormatObj = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    });

    return FormatObj.format(price);
};
